import * as React from 'react';
import { toastr } from "react-redux-toastr";
import { EmailsConfigurationService } from "src/share/services/emails-configuration";
import { IEmailsLogs, initialEmailsLogsRequest } from 'src/share/types/emailsConfiguration';

const { useState, useEffect } = React;
export const useEmailsLogs = () => {
  const [data, setData] = useState<IEmailsLogs[]>([]);
  const [searchLogs, setSearchLogs] = React.useState(initialEmailsLogsRequest);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [total, setTotal] = useState(0);
  const loadEmailsConfiguration = async () => {
    try {
      setLoading(true);
      const { results, total: count } = await EmailsConfigurationService.getLogs(searchLogs);
      setData(results as IEmailsLogs[]);
      setTotal(count);
      setLoading(false);
    } catch {
      toastr.error("Error", "There was a problem loading the email configuration");
      setLoading(false);
    }
  }
  const handleSort = (column, sortDirection): void => {
    setSearchLogs(prevSearch => ({ ...prevSearch, sort: [{ [column.selector]: sortDirection }] }));
  }
  useEffect(() => {
    loadEmailsConfiguration();
  }, [searchLogs]);
  return [{ data, isLoading, total }, { setSearchLogs, handleSort }] as [IEmailsConfigurationState, any];
}

interface IEmailsConfigurationState {
  data: IEmailsLogs[];
  isLoading: boolean;
  total: number;
}
